import { createContext } from 'react';
import { SoundsUtil } from '../hooks/useSounds';

const SoundsContext = createContext<SoundsUtil | null>(null);

export default SoundsContext;
